export default __webpack_public_path__ + "media/govRound.bfa0d03b.png";